import {
  CONNECT_TO_XERO,
  DISCONNECT_TO_XERO,
  SET_XERO_ACCOUNTS,
  GET_XERO_ACCOUNTS,
  SET_PAYMENT_TYPES_XERO,
  GET_PAYMENT_TYPES_XERO,
  SET_TILL_MOVEMENT_TYPES_XERO,
  GET_TILL_MOVEMENT_TYPES_XERO,
  SET_TAX_GROUP_XERO,
  GET_TAX_GROUP_XERO,
  SET_XERO_TAX_RATES,
  GET_XERO_TAX_RATES,
  MANUAL_SYNC,
} from '../constants/constant_xero';

export function connectXero(id) {
  return { type: CONNECT_TO_XERO, id };
}

export function disconnectXero(id) {
  return { type: DISCONNECT_TO_XERO, id };
}

export function setXeroAccounts(payload) {
  return { type: SET_XERO_ACCOUNTS, payload };
}

export function getXeroAccounts(id) {
  return { type: GET_XERO_ACCOUNTS, id };
}

export function setPaymentTypesXero(payload) {
  return { type: SET_PAYMENT_TYPES_XERO, payload };
}

export function getPaymentTypesXero() {
  return { type: GET_PAYMENT_TYPES_XERO };
}

export function setTillMovementTypesXero(payload) {
  return { type: SET_TILL_MOVEMENT_TYPES_XERO, payload };
}

export function getTillMovementTypesXero() {
  return { type: GET_TILL_MOVEMENT_TYPES_XERO };
}

export function setTaxGroupsXero(payload) {
  return { type: SET_TAX_GROUP_XERO, payload };
}

export function getTaxGroupsXero() {
  return { type: GET_TAX_GROUP_XERO };
}

export function setXeroTaxRates(payload) {
  return { type: SET_XERO_TAX_RATES, payload };
}

export function getXeroTaxRates(id) {
  return { type: GET_XERO_TAX_RATES, id };
}

export function manualSync(id) {
  return { type: MANUAL_SYNC, id };
}
